module.exports = __webpack_public_path__ + "static/media/some-experience.9dd14b7f.svg";